import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import ArtisanComment from "../../entity/b2csdu/ArtisanComment";

const SERVICE = "service-b2csdu";
const ENTITY = "artisan_comments";

export default function () {
    const {findOneBy, create} = useApi();
    const state = useSelector;
    const newInstance = data => new ArtisanComment(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.b2csdu?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7");
                }
            }
        },
        async create(payload) {
            return create(SERVICE, ENTITY, payload, newInstance, "application_v7");
        },
    }
}